import { useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import "./PricingSection.css";
import QrCorners from "./QrCorners";

const gridVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 26, scale: 1 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] } },
};

const featuredCardVariants = {
  hidden: { opacity: 0, y: 26, scale: 0.98 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1.03,
    transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] },
  },
};

const PLANS = [
  {
    id: "lite",
    name: "Lite",
    monthly: 2490,
    yearly: 1990,
    description: "Digitális étlap QR-kóddal",
    features: [
      "Digitális étlap",
      "QR kód az étlaphoz",
      "Valós idejű menüfrissítés",
      "Egyedi URL",
    ],
    trial: true,
    featured: false,
  },
  {
    id: "basic",
    name: "Basic",
    monthly: 4990,
    yearly: 3990,
    description: "Digitális étlap és QR-kódos rendelés egy rendszerben",
    features: [
      "Minden a Lite-ból",
      "QR-kódos rendelés",
      "Pincér rendelésfelvétel",
      "Pincér hívása egy gombbal",
      "Asztalkezelés",
    ],
    trial: true,
    featured: true,
  },
  {
    id: "pro",
    name: "Pro",
    monthly: 9990,
    yearly: 7990,
    description: "A teljes rendszer — foglalással és eseményekkel",
    features: [
      "Minden a Basic-ból",
      "Asztalfoglalás és események",
      "Wolt étlap-szinkron",
      "Magasabb limitek (asztal, termék, csapat)",
      "Kiemelt támogatás",
    ],
    trial: true,
    featured: false,
  },
];

function PricingSection() {
  const [yearly, setYearly] = useState(true);
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="landing-section" id="pricing">
      <h2 className="landing-section-title fade-up">Árazás</h2>

      <p className="landing-pricing-subtitle fade-up">
        Egyszerű és átlátható csomagok éttermeknek
      </p>

      <div className="landing-pricing-toggle fade-up" role="group" aria-label="Számlázási időszak">
        <button
          type="button"
          className={!yearly ? "active" : ""}
          onClick={() => setYearly(false)}
          aria-pressed={!yearly}
        >
          Havi
        </button>
        <button
          type="button"
          className={yearly ? "active" : ""}
          onClick={() => setYearly(true)}
          aria-pressed={yearly}
        >
          Éves <span className="landing-pricing-save">-20%</span>
        </button>
      </div>

      <motion.div
        className="landing-pricing-grid"
        initial={prefersReducedMotion ? false : "hidden"}
        whileInView={prefersReducedMotion ? undefined : "show"}
        viewport={{ once: true, amount: 0.25 }}
        variants={prefersReducedMotion ? undefined : gridVariants}
      >
        {PLANS.map((plan) => (
          <motion.div
            key={plan.id}
            className={`landing-price-card${
              plan.featured ? " landing-price-card-featured" : ""
            }`}
            variants={
              prefersReducedMotion
                ? undefined
                : plan.featured
                  ? featuredCardVariants
                  : cardVariants
            }
            whileHover={
              prefersReducedMotion
                ? undefined
                : { y: -8, scale: plan.featured ? 1.05 : 1.02 }
            }
          >
            {plan.featured && (
              <>
                <div className="landing-popular-badge">Legnépszerűbb</div>
                <QrCorners tone="ink" />
              </>
            )}

            <div className="landing-price-plan">{plan.name}</div>

            <div className="landing-price">
              {(yearly ? plan.yearly : plan.monthly).toLocaleString("hu-HU")}
              {" Ft"}
              <span>/ hó</span>
            </div>

            {yearly && (
              <div className="landing-price-strike">
                {plan.monthly.toLocaleString("hu-HU")} Ft/hó havi díjjal
              </div>
            )}

            <p className="landing-price-description">{plan.description}</p>

            {plan.trial && (
              <div className="landing-price-trial-badge">
                14 napos ingyenes próba
              </div>
            )}

            <div className="landing-price-features">
              {plan.features.map((f) => (
                <div key={f}>✓ {f}</div>
              ))}
            </div>

            <div className="landing-price-footer">
              <a
                href="https://app.tablify.hu/register"
                className="landing-btn-primary"
              >
                Kipróbálom
              </a>
            </div>
          </motion.div>
        ))}
      </motion.div>

      <p className="landing-pricing-footnote fade-up">
        + Kitchen Display kiegészítő is elérhető (egyszeri vásárlás), minden
        csomaghoz hozzáadható.
      </p>
    </section>
  );
}

export default PricingSection;
